.footer {
  width: 390px;
  margin-inline: auto;
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  text-align: center;
  background: #f9f9f9;
}

.content {
  display: inline-block;
  padding: 24px 0;
}

.linkList {
  display: flex;
}

.linkItem {
  & + & {
    margin-left: 40px;
  }
}

.contactList {
  margin-top: 24px;
  text-align: center;
}

.contactItem {
  & + & {
    margin-top: 24px;
  }
}

.copyright {
  display: block;
  margin-top: 24px;
}
